import React from 'react';
import { SpinnerContainer, StyledCircularProgress, LoadingText } from './LoadingSpinner.styles';

const LoadingSpinner: React.FC = () => {
  return (
    <SpinnerContainer>
      <StyledCircularProgress size={60} />
      <LoadingText variant="h6">
        Loading...
      </LoadingText>
    </SpinnerContainer>
  );
};

export default LoadingSpinner;
